import { useTranslation } from "react-i18next";
import { SvgIcon } from "../../SvgIcon";
import "./index.scss";
import { Col, Row, message } from "antd";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { IS_MOBILE } from "@/utils/tool";
import sentry4Action from "@/utils/sentry";
import useLanguage from "@/hooks/useLanguage";

/**
 * 拆分子订单列表
 * @param childOrdrList
 * @returns
 */
const ChildOrder = (props: { childOrdrList: Array<ChildOrder> }) => {
  const { childOrdrList } = props;
  const { t } = useTranslation();
  const { language } = useLanguage();
  const [messageApi, contextHolder] = message.useMessage();
  const copyUrl = (order: ChildOrder) => {
    sentry4Action("复制支付链接", {});
    messageApi.success(t("复制成功"));
  };
  return (
    <>
      {contextHolder}
      <div
        className={`child-order-box ${language === "en" ? "en-child-order-box" : ""}`}
      >
        {/* <div className="head-title">{t("其他拆分订单")}</div> */}
        <div className="child-order-list">
          {childOrdrList.map((child) => {
            return (
              <Row className="child-order-item" key={child.order_id}>
                <Col span={24} className="pay-code">
                  <span>{t("支付号")}：</span>
                  <span>{child.order_id}</span>
                </Col>
                <Col span={24} sm={24} md={12} className="tell-info">
                  <span>{t("联系人")}：</span>
                  <span>{child.apc_user_real_name}</span>
                </Col>
                <Col span={24} sm={24} md={12}>
                  <span>{t("手机号")}：</span>
                  <span>{child.apc_user_mobile}</span>
                </Col>
                <Col span={24} sm={24} md={12} className="money">
                  <span>{t("金额")}：</span>
                  <span>¥{Number(child.total_money).toFixed(2)}</span>
                </Col>
                <Col span={24} sm={24} md={12} className="copy">
                  <SvgIcon icon="icon-fuzhi" width={16} height={16} />
                  <CopyToClipboard text={child.pay_url}>
                    <span onClick={() => copyUrl(child)}>
                      {t("复制支付链接")}
                    </span>
                  </CopyToClipboard>
                </Col>
              </Row>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default ChildOrder;
